<div class="dialog item-designer-dialog">
  <h3>Item Designer</h3>

  <div class="preview-wrapper">
    <app-rule-preview [compact]="true" [largeBackground]="true" [rules]="[previewRule]"></app-rule-preview>
  </div>

  <div class="item-designer-body poe-scrollbar">
    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="filter-body">
            <span filter-title text="Item Properties">
            </span>
          </span>
        </div>
      </div>
      <div class="filter-group-body">

    <div class="filter full-span">
      <span class="filter-body">
        <div class="filter-title" style="width: 90px">Item Type</div>
        <span class="sep"></span>
        <app-select [searchable]="true" [(ngModel)]="selectedItemType" (selectedValueChange)="onItemTypeChange()" style="min-width: 200px;">
          <app-option [value]="''" [text]="'Select a type'"></app-option>
          @for (type of itemData; track type.itemType) {
            <app-option [value]="type.itemType" [text]="type.itemType"
              [imgUrl]="imgPrefix + type.baseTypes[0].image" [alt]="type.itemType" [width]="'16px'" [height]="'16px'">
            </app-option>
          }
        </app-select>
      </span>
    </div>

    @if (showDefenceType) {
      <div class="filter full-span">
        <span class="filter-body">
          <div class="filter-title" style="width: 90px">Defence</div>
          <span class="sep"></span>
          <app-select [(ngModel)]="selectedDefenceType" (selectedValueChange)="onDefenceTypeChange()" style="min-width: 130px;">
            <app-option [value]="''" [text]="'Any'"></app-option>
            <app-option [value]="'Arm'" [text]="'Armour'" [imgUrl]="imgPrefix + '/img/shields/shield-red.png'" [width]="'16px'" [height]="'16px'"></app-option>
            <app-option [value]="'Eva'" [text]="'Evasion'" [imgUrl]="imgPrefix + '/img/shields/shield-green.png'" [width]="'16px'" [height]="'16px'"></app-option>
            <app-option [value]="'ES'" [text]="'Energy Shield'" [imgUrl]="imgPrefix + '/img/shields/shield-blue.png'" [width]="'16px'" [height]="'16px'"></app-option>
            <app-option [value]="'Arm/Eva'" [text]="'Arm/Eva'" [imgUrl]="imgPrefix + '/img/shields/shield-red-green.png'" [width]="'16px'" [height]="'16px'"></app-option>
            <app-option [value]="'Arm/ES'" [text]="'Arm/ES'" [imgUrl]="imgPrefix + '/img/shields/shield-red-blue.png'" [width]="'16px'" [height]="'16px'"></app-option>
            <app-option [value]="'Eva/ES'" [text]="'Eva/ES'" [imgUrl]="imgPrefix + '/img/shields/shield-green-blue.png'" [width]="'16px'" [height]="'16px'"></app-option>
          </app-select>
        </span>
      </div>
    }

    @if (selectedItemType && baseTypeOptions.length > 1) {
      <div class="filter full-span">
        <span class="filter-body">
          <div class="filter-title" style="width: 90px">Base Type</div>
          <span class="sep"></span>
          <app-select [searchable]="true" [(ngModel)]="selectedBaseType" (selectedValueChange)="onBaseTypeChange($event)" style="min-width: 200px;">
            @for (bt of baseTypeOptions; track bt.name) {
              <app-option [value]="bt.name" [text]="bt.name"
                [imgUrl]="bt.image ? imgPrefix + bt.image : ''"
                [width]="'16px'" [height]="'16px'"
                [gearTier]="$any(bt.gearTier)"></app-option>
            }
          </app-select>
        </span>
      </div>
    }

    @if (selectedItemClass) {

      @if (showRarity || showItemLevel) {
        <div class="filter full-span">
          <span class="filter-body">
            @if (showRarity) {
              <div class="filter-title" style="width: 90px">Rarity</div>
              <span class="sep"></span>
              <app-select-rarity [includeUnique]="true" [(ngModel)]="rarity" (selectedValueChange)="recomputeVisibilityAndPreview()" style="width: 120px;"></app-select-rarity>
            }
            @if (showItemLevel) {
              @if (showRarity) { <span class="sep"></span> }
              <div class="filter-title" [class.filter-label]="showRarity" style="width: 90px">Item lvl</div>
              <span class="sep"></span>
              <input type="number" placeholder="1-85" min="1" max="85" maxlength="3" pattern="[0-9]*" inputmode="numeric" step="any"
                class="form-control minmax" style="width: 64px;"
                [(ngModel)]="itemLevel" (ngModelChange)="updatePreview()">
            }
          </span>
        </div>
      }

      @if (showQuality || showCorrupted || showStackSize) {
        <div class="filter full-span">
          <span class="filter-body">
            @if (showQuality) {
              <div class="filter-title" style="width: 90px">Quality</div>
              <span class="sep"></span>
              <input type="number" placeholder="0-30" min="0" max="30" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any"
                class="form-control minmax" style="width: 64px;"
                [(ngModel)]="quality" (ngModelChange)="updatePreview()">
            }
            @if (showCorrupted) {
              @if (showQuality) { <span class="sep"></span> }
              <div class="filter-title" [class.filter-label]="showQuality" style="width: 90px">Corrupted</div>
              <span class="sep"></span>
              <app-select [(ngModel)]="corrupted" (selectedValueChange)="updatePreview()" style="width: 65px;">
                <app-option [value]="undefined" [text]="'Any'"></app-option>
                <app-option [value]="true" [text]="'Yes'"></app-option>
                <app-option [value]="false" [text]="'No'"></app-option>
              </app-select>
            }
            @if (showStackSize) {
              @if (showQuality || showCorrupted) { <span class="sep"></span> }
              <div class="filter-title filter-label">Stack Size</div>
              <span class="sep"></span>
              <input type="number" placeholder="1" min="1" maxlength="5" pattern="[0-9]*" inputmode="numeric" step="any"
                class="form-control minmax" style="width: 64px;"
                [(ngModel)]="stackSize" (ngModelChange)="updatePreview()">
            }
          </span>
        </div>
      }

      @if (showSockets) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">Sockets</div>
            <span class="sep"></span>
            <input type="number" placeholder="0-{{ maxSockets }}" min="0" [max]="maxSockets" maxlength="1" pattern="[0-9]*" inputmode="numeric" step="any"
              class="form-control minmax" style="width: 64px;"
              [(ngModel)]="sockets" (ngModelChange)="updatePreview()">
            @if (poe1) {
              <span class="sep"></span>
              <div class="filter-title filter-label">Links</div>
              <span class="sep"></span>
              <input type="number" min="0" [max]="maxSockets" maxlength="1" pattern="[0-9]*" inputmode="numeric" step="any"
                class="form-control minmax" style="width: 64px;"
                [(ngModel)]="linkedSockets" (ngModelChange)="updatePreview()">
              <span class="sep"></span>
              <div class="filter-title filter-label" style="width: 65px">
                <span class="filter-title-text">Socketgroup</span>
              </div>
              <span class="sep"></span>
              <input type="text" placeholder="RGBWX" [maxlength]="maxSockets" pattern="[RGBWXT]{1,6}"
                class="form-control" style="min-width: 90px; width: 90px;"
                [(ngModel)]="socketGroup" (ngModelChange)="updatePreview()">
            }
          </span>
        </div>
      }

      @if (poe1 && showSockets) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">Memory Strands</div>
            <span class="sep"></span>
            <input type="number" placeholder="min" min="1" max="10" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any"
              class="form-control minmax" style="width: 64px;"
              [(ngModel)]="memoryStrands" (ngModelChange)="updatePreview()">
          </span>
        </div>
      }

      @if (showPoe1Equipment) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">
              <span class="filter-title-text">Equipment</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!hasInfluence" (click)="hasInfluence = !hasInfluence; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Influenced</span>
            </div>
            @if (hasInfluence) {
              <span class="sep"></span>
              <app-autocomplete
                [options]="influenceOptions"
                [allowAll]="true"
                [allowNone]="false"
                [showOptions]="true"
                [showTooltip]="false"
                [selectedValues]="selectedInfluences"
                (selectedValuesChange)="selectedInfluences = $event; updatePreview()"
                style="width: 150px;">
              </app-autocomplete>
            }
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!fracturedItem" (click)="fracturedItem = !fracturedItem; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Fractured</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!synthesisedItem" (click)="synthesisedItem = !synthesisedItem; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Synthesised</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!shaperItem" (click)="shaperItem = !shaperItem; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Shaper Item</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!elderItem" (click)="elderItem = !elderItem; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Elder Item</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!mirrored" (click)="mirrored = !mirrored; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Mirrored</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!replica" (click)="replica = !replica; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Replica</span>
            </div>
          </span>
        </div>
      }

      @if (showWaystone) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">
              <span class="filter-title-text">{{ poe2 ? 'Waystone' : 'Map' }}</span>
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="1-16" min="1" max="16" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any"
              class="form-control minmax" style="width: 64px;"
              [(ngModel)]="waystoneTier" (ngModelChange)="updatePreview()">
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button type="button" class="btn toggle-btn" [class.off]="!anyEnchantment" (click)="anyEnchantment = !anyEnchantment; updatePreview()"></button>
              </span>
              <span class="table-checkbox-label">Any Enchantment</span>
            </div>
            @if (poe1) {
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button type="button" class="btn toggle-btn" [class.off]="!blightedMap" (click)="blightedMap = !blightedMap; updatePreview()"></button>
                </span>
                <span class="table-checkbox-label">Blighted</span>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button type="button" class="btn toggle-btn" [class.off]="!uberBlightedMap" (click)="uberBlightedMap = !uberBlightedMap; updatePreview()"></button>
                </span>
                <span class="table-checkbox-label">Blight-Ravaged</span>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button type="button" class="btn toggle-btn" [class.off]="!elderMap" (click)="elderMap = !elderMap; updatePreview()"></button>
                </span>
                <span class="table-checkbox-label">Elder Map</span>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button type="button" class="btn toggle-btn" [class.off]="!shapedMap" (click)="shapedMap = !shapedMap; updatePreview()"></button>
                </span>
                <span class="table-checkbox-label">Shaped Map</span>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button type="button" class="btn toggle-btn" [class.off]="!zanaMemory" (click)="zanaMemory = !zanaMemory; updatePreview()"></button>
                </span>
                <span class="table-checkbox-label">Zana Memory</span>
              </div>
            }
          </span>
        </div>
      }

      @if (showGem) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">Gem Level</div>
            <span class="sep"></span>
            <input type="number" placeholder="1-21" min="1" max="21" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any"
              class="form-control minmax" style="width: 64px;"
              [(ngModel)]="gemLevel" (ngModelChange)="updatePreview()">
            @if (showGemQualityType) {
              <span class="sep"></span>
              <div class="filter-title filter-label">Quality Type</div>
              <span class="sep"></span>
              <app-select [(ngModel)]="gemQualityType" (selectedValueChange)="updatePreview()" style="width: 140px;">
                @for (qt of gemQualityTypes; track qt) {
                  <app-option [value]="qt" [text]="qt"></app-option>
                }
              </app-select>
              <span class="sep"></span>
              <div class="filter-title filter-label" style="width: 150px">
                <span class="filter-title-text">Transfigured Gem</span>
              </div>
              <span class="sep"></span>
              <app-select [(ngModel)]="transfiguredGem" (selectedValueChange)="updatePreview()" style="width: 300px;">
                <app-option [value]="''" [text]="'None'"></app-option>
                @for (gem of transfiguredGems; track gem) {
                  <app-option [value]="gem" [text]="gem"></app-option>
                }
              </app-select>
            }
          </span>
        </div>
      }

      @if (showClusterJewel) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 150px">
              <span class="filter-title-text">Cluster Jewels</span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label">Passives</div>
            <span class="sep"></span>
            <input type="number" min="2" max="12" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any"
              class="form-control minmax" style="width: 64px;"
              [(ngModel)]="enchantmentPassiveNum" (ngModelChange)="updatePreview()">
          </span>
        </div>
      }

      @if (showIdentification) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">Identified</div>
            <span class="sep"></span>
            <app-select [(ngModel)]="identified" (selectedValueChange)="recomputeVisibilityAndPreview()" style="width: 65px;">
              <app-option [value]="undefined" [text]="'Any'"></app-option>
              <app-option [value]="true" [text]="'Yes'"></app-option>
              <app-option [value]="false" [text]="'No'"></app-option>
            </app-select>
            @if (identified === true) {
              @if (showRareName) {
                <span class="sep"></span>
                <div class="filter-title filter-label">Rare Name</div>
                <span class="sep"></span>
                <input type="text" placeholder="Optional" maxlength="100"
                  class="form-control" style="min-width: 160px; width: 160px;"
                  [(ngModel)]="rareName" (ngModelChange)="updatePreview()">
              }
              <span class="sep"></span>
              <div class="filter-title filter-label">Implicits</div>
              <span class="sep"></span>
              <input type="number" placeholder="0-4" min="0" max="4" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any"
                class="form-control minmax" style="width: 64px;"
                [(ngModel)]="implicitModCount" (ngModelChange)="updatePreview()">
            }
            @if (showUnidentifiedTier) {
              <span class="sep"></span>
              <div class="filter-title filter-label">Unid. Tier</div>
              <span class="sep"></span>
              <input type="number" placeholder="1-5" min="1" max="5" maxlength="1" pattern="[1-5]" inputmode="numeric" step="any"
                class="form-control minmax" style="width: 64px;"
                [(ngModel)]="unidentifiedItemTier" (ngModelChange)="updatePreview()">
            }
          </span>
        </div>
      }

      @if (showIdentification && identified === true) {
        <div class="filter full-span">
          <span class="filter-body">
            <div class="filter-title" style="width: 90px">Explicits</div>
            <span class="sep"></span>
            <app-select [searchable]="true" [displayMode]="'textOnly'" [fullWidth]="true"
              [(ngModel)]="modPickerValue" (selectedValueChange)="onModPicked($event)" style="width: 100%; min-width: 250px;">
              <app-option [value]="undefined" [text]="'Add mod…'"></app-option>
              @for (mod of modOptions; track mod.key) {
                <app-option [value]="mod.key" [text]="mod.text" [modName]="mod.name"></app-option>
              }
            </app-select>
          </span>
        </div>
      }

    }

      </div>
    </div>

    @if (explicitMods.length > 0) {
      <div class="mod-tags">
        @for (mod of explicitMods; track $index) {
          <span class="mod-tag">
            {{ mod }}
            <button type="button" class="mod-tag-remove" (click)="removeExplicitMod($index)">✕</button>
          </span>
        }
      </div>
    }

    <div class="preview-status">
      <app-simulator-result-summary [result]="simResult"></app-simulator-result-summary>
    </div>

    @if (isDevMode) {
      <div class="filter-group debug-json-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="filter-body">
              <span filter-title text="Item JSON">
              </span>
            </span>
          </div>
        </div>
        <div class="filter-group-body">
          <pre class="debug-json poe-scrollbar">{{ debugItemJson }}</pre>
        </div>
      </div>
    }
  </div>

  <div class="dialog-controls">
    <button class="btn dialog-btn dialog-main-btn" [disabled]="!canAddToLibrary" (click)="onAddToLibrary()">
      Add to Library
    </button>
    <button class="btn dialog-btn dialog-cancel-btn" (click)="onCancel()">Cancel</button>
  </div>
</div>
